import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class ModifierCodeObjetMaquetteCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private oldCode: string,
        private newCode: string
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierCodeObjetMaquette(this.id, this.version, this.newCode)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierCodeObjetMaquette(this.id, this.version, this.oldCode)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }
}
